import { useCallback, useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { cancelOrder, createOrder } from "../api/order.api";
import { DataContext } from "../contexts/DataContext";
import { showToast } from "../utils/showToast";
import { useRouter } from "next/router";
export default function useChooseTicket({
  eventId,
  onNextStep,
  onFetchTicketByEvent,
  oldOrder,
  setOldOrder,
  onGetOldOrder,
}) {
  const { t } = useTranslation();

  const [isLoadingCreateOrder, setIsLoadingCreateOrder] = useState(false);
  const {
    setTicketUserBuy,
    dataTicketForCreateOrder,
    setCurrentOrder,
    onResetData,
  } = useContext(DataContext);
  const [isLoadingCancelOrder, setLoadingCancelOrder] = useState(false);

  const handleCancelOrder = useCallback(async () => {
    try {
      if (isLoadingCancelOrder) return;
      setLoadingCancelOrder(true);
      const response = await cancelOrder(oldOrder?.order?.id);
      if (response.status === 200) {
        setTicketUserBuy([]);
        setOldOrder(null);
      }
      onFetchTicketByEvent();
      setLoadingCancelOrder(false);
      showToast({ message: "Cancel Order success", type: "success" });
    } catch (error) {
      console.log("error", error);
      setLoadingCancelOrder(false);
      showToast({ message: "Cancel Order failed!", type: "error" });
    }
  }, [
    oldOrder?.order?.id,
    isLoadingCancelOrder,
    setTicketUserBuy,
    onFetchTicketByEvent,
    setOldOrder,
  ]);
  const router = useRouter();

  const onCreateOrder = useCallback(async () => {
    try {
      if (isLoadingCreateOrder) return;
      if (oldOrder?.isExist && oldOrder?.order?.status === "PENDING") {
        const dataOldOrder = {
          ...oldOrder.order,
          eventId,
        };

        setCurrentOrder(dataOldOrder);
        onNextStep();
        return;
      }

      setIsLoadingCreateOrder(true);
      const response = await createOrder({
        eventId,
        items: dataTicketForCreateOrder,
      });
      await onGetOldOrder(eventId);
      if (response?.data?.status === "SUCCESS") {
        showToast({ message: t("orders.create_success"), type: "success" });
        setCurrentOrder({
          ...response.data,
          eventId,
        });
        setTimeout(() => {
          router.push("/my-ticket");
        }, 250);
        setIsLoadingCreateOrder(false);
        return;
      }
      setCurrentOrder({
        ...response.data,
        eventId,
      });
      showToast({ message: t("orders.create_success"), type: "success" });
      onNextStep();
      setIsLoadingCreateOrder(false);
    } catch (error) {
      setIsLoadingCreateOrder(false);
      if (
        error?.response?.data?.order === null &&
        error?.response?.data?.statusCode === 400
      ) {
        const itemErrors = error?.response?.data?.error?.itemErrors;

        if (itemErrors) {
          const errorMessages = itemErrors.map((error, index) => {
            return error.message[0];
          });
          const errorMessage = errorMessages.join("\n");
          showToast({
            message: errorMessage,
            type: "error",
          });
        }
      }

      onFetchTicketByEvent();
      onResetData();
    }
  }, [
    isLoadingCreateOrder,
    dataTicketForCreateOrder,
    t,
    onNextStep,
    eventId,
    setCurrentOrder,
    onGetOldOrder,
  ]);

  return {
    onCreateOrder,
    isLoadingCreateOrder,
    dataTicketForCreateOrder,
    isLoadingCancelOrder,
    handleCancelOrder,
  };
}
